import { useModal } from '../../../../../hooks/useModal'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'
import { useUser } from '../../../../../redux/reducer/user'
import { useContent } from '../../../../../redux/reducer/content'
import { BUTTONS, IMAGE, TITLE, USER_BILLET } from '../../../universalModal'
import { CLOSE, SEND } from '../../constants/actions'
import content from '../../constants/content'
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle'

const { sendModal } = content

export default function useButtonCallbacks({ activeShopItemObject }) {
  const { profile: { money, gacha_event_cash, beauties } = {} } = useUser()
  const { viewedFriend } = useContent()
  const callbacks = useApplicationCallbacks()
  const { id, closeModal, addModal } = useModal()
  const gameTamagotchiBeauties = useFeatureToggle('gameTamagotchiBeauties')
  const secondCurrencyBalance = gameTamagotchiBeauties ? beauties : gacha_event_cash

  return {
    [SEND]() {
      const { cost, giftCost, beautiesCost } = activeShopItemObject ?? {}
      const secondCurrencyPrice = gameTamagotchiBeauties ? beautiesCost : giftCost
      const totalPrice = cost || secondCurrencyPrice
      const isCoinPrice = !!totalPrice && totalPrice === cost
      const isSecondCurrencyPrice =
        !!totalPrice && !isCoinPrice && totalPrice === secondCurrencyPrice
      const isInsufficientSecondCurrency =
        typeof secondCurrencyBalance !== 'number' || secondCurrencyPrice > secondCurrencyBalance
      const isDisabled = isCoinPrice
        ? cost > money
        : isSecondCurrencyPrice
        ? isInsufficientSecondCurrency
        : false

      const {
        buttons: [buy, close],
        title,
      } = sendModal

      addModal({
        type: 'universalModal',
        props: {
          modalProps: { wrapper: { isFullPage: false }, modifier: 'noFullNoScroll' },
          components: [
            {
              list: [
                {
                  type: TITLE,
                  props: {
                    modifier: ['middleMar', 'padding-no'],
                    value: title,
                  },
                },
                {
                  type: USER_BILLET,
                  props: {
                    modifier: ['full-width'],
                    userData: viewedFriend,
                    onClick() {
                      callbacks.setIsVisible(true)
                      addModal({ type: 'profileModal' })
                    },
                  },
                },
                {
                  type: IMAGE,
                  props: {
                    modifier: ['min-height'],
                    img: activeShopItemObject.preview_image,
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: [
                      {
                        ...buy,
                        disabled: isDisabled,
                        coins: isCoinPrice,
                        gifts: !gameTamagotchiBeauties && isSecondCurrencyPrice,
                        beauties: gameTamagotchiBeauties && isSecondCurrencyPrice,
                        count: totalPrice,
                        onClick() {
                          const requestParams = {
                            uid: Number(viewedFriend?.uid),
                            id: activeShopItemObject?.id,
                          }
                          if (!totalPrice) callbacks.buyWishGift(requestParams)
                          else if (isCoinPrice && money >= cost) {
                            callbacks.buyWishGift(requestParams)
                          } else if (
                            isSecondCurrencyPrice &&
                            secondCurrencyBalance >= secondCurrencyPrice
                          ) {
                            callbacks.buyWishGift(requestParams)
                          }
                        },
                      },
                      close,
                    ],
                  },
                },
              ],
            },
          ],
        },
      })
    },
    [CLOSE]() {
      closeModal({ id })
    },
  }
}
